import React from 'react';
import {Box, Typography} from '@material-ui/core';
import LocalOfferOutlinedIcon from '@material-ui/icons/LocalOfferOutlined';
import PanelChangeSspIcon from './PanelChangeSspIcon';

const PanelChangeTitle = ({
  classes,
  primaryLine,
  secondaryLine = null,
  sspLogo = null,
  isTagLevel = false,
}) => {
  if (secondaryLine) {
    return (
      <Box className={classes.summaryGroupTitle}>
        <Box className={classes.summaryGroupTitlePrimary}>
          {isTagLevel ? (
            <LocalOfferOutlinedIcon className={classes.tagIcon} aria-hidden />
          ) : (
            <PanelChangeSspIcon src={sspLogo} className={classes.sspIcon} />
          )}
          <Typography component="span" variant="body2" className={classes.changeLogTitlePrimary}>
            {primaryLine}
          </Typography>
        </Box>
        <Typography variant="body2" className={classes.summaryGroupTitleSecondary}>
          {secondaryLine}
        </Typography>
      </Box>
    );
  }

  return (
    <Box className={classes.summaryGroupTitlePrimary}>
      {isTagLevel ? (
        <LocalOfferOutlinedIcon className={classes.tagIcon} aria-hidden />
      ) : (
        <PanelChangeSspIcon src={sspLogo} className={classes.sspIcon} />
      )}
      <Typography component="span" variant="body2" className={classes.changeLogTitlePrimary}>
        {primaryLine}
      </Typography>
    </Box>
  );
};

export default React.memo(PanelChangeTitle);
